import React from "react"

import classNames from "classnames"

import { times } from "shared/lib/times"
import { InstallationReference } from "shared/types/InstallationReference"
import { ImageOverlayPayload } from "shared/ui/image-overlay/ImageOverlay"

import { InstallationReferenceCard } from "../installation-reference-card/InstallationReferenceCard"
import { LoadingInstallationReferenceCard } from "../installation-reference-card/LoadingInstallationReferenceCard"

export interface InstallationReferenceSelectionListViewModel {
  installationReferences: InstallationReference[] | null | undefined
  selectedInstallationReferenceIDs: string[]

  noItemText: string

  isLoading?: boolean
  loadingItemAmount?: number

  className?: string
  onSelect: (id: string) => void
  onZoomImage: (payload: ImageOverlayPayload) => void
}

export const InstallationReferenceSelectionListView = React.memo(
  ({
    installationReferences,
    selectedInstallationReferenceIDs,
    isLoading,
    loadingItemAmount = 4,
    className,
    noItemText,
    onSelect,
    onZoomImage
  }: InstallationReferenceSelectionListViewModel) => {
    if (isLoading) {
      return (
        <div
          className={classNames("install-ref-select-list loading", className)}
        >
          {times(loadingItemAmount, index => (
            <LoadingInstallationReferenceCard key={index} />
          ))}
        </div>
      )
    }
    return (
      <div
        className={classNames(
          "install-ref-select-list",
          { "no-items": installationReferences?.length === 0 },
          className
        )}
      >
        {installationReferences && installationReferences?.length > 0 ? (
          installationReferences.map(installationReference => (
            <InstallationReferenceCard
              key={installationReference.id}
              installationReference={installationReference}
              isSelected={selectedInstallationReferenceIDs.includes(
                installationReference.id
              )}
              onSelect={onSelect}
              onZoomImage={onZoomImage}
            />
          ))
        ) : (
          <div className="install-ref-select-list__no-item-text">
            {noItemText}
          </div>
        )}
      </div>
    )
  }
)
